export default __webpack_public_path__ + "static/media/underline.b0ce81d9.svg";